/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyAcceptCodeLabel,
  PharmacyAcceptCodeLabelFromJSON,
  PharmacyAcceptCodeLabelFromJSONTyped,
  PharmacyAcceptCodeLabelToJSON,
} from "./";

export const PharmacyPharmacyCrowdStatusTypename = "PharmacyPharmacyCrowdStatus" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyCrowdStatus
 */
export interface PharmacyPharmacyCrowdStatus {
  /**
   *
   * @type {Array<PharmacyAcceptCodeLabel>}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  acceptCodeLabels?: Array<PharmacyAcceptCodeLabel>;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  enableAcceptCodeMultiLine?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  quantity?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  unitType: PharmacyPharmacyCrowdStatusUnitTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  updatedTime?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyCrowdStatus
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyCrowdStatusUnitTypeEnum {
  People = "people",
  Minute = "minute",
}

export function PharmacyPharmacyCrowdStatusFromJSON(json: any): PharmacyPharmacyCrowdStatus {
  return PharmacyPharmacyCrowdStatusFromJSONTyped(json, false);
}

export function PharmacyPharmacyCrowdStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyCrowdStatus {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyCrowdStatusTypename,

    acceptCodeLabels: !exists(json, "accept_code_labels")
      ? undefined
      : (json["accept_code_labels"] as Array<any>).map(PharmacyAcceptCodeLabelFromJSON),
    enableAcceptCodeMultiLine: !exists(json, "enable_accept_code_multi_line")
      ? undefined
      : json["enable_accept_code_multi_line"],
    quantity: !exists(json, "quantity") ? undefined : json["quantity"],
    unitType: json["unit_type"],
    updatedTime:
      !exists(json, "updated_time") ||
      (typeof json["updated_time"] === "string" && json["updated_time"].substring(0, 4) === "0001")
        ? undefined
        : json["updated_time"],
  };
}

export function PharmacyPharmacyCrowdStatusToJSON(object?: PharmacyPharmacyCrowdStatus | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code_labels:
      value.acceptCodeLabels === undefined
        ? undefined
        : (value.acceptCodeLabels as Array<any>).map(PharmacyAcceptCodeLabelToJSON),
    enable_accept_code_multi_line: value.enableAcceptCodeMultiLine,
    quantity: value.quantity,
    unit_type: value.unitType,
    updated_time: value.updatedTime === undefined ? undefined : tzDate(value.updatedTime).format(),
  };
}
